const apiStringServer = 'https://kambiental-server.kintelligence.com.br:3346';

export default apiStringServer;